<template>
    <q-page>
        <div class="q-display-1">Aktywności</div>

        <activity-entry
            v-for="activity in activities"
            :key="activity.activityTypeId"
            :model="activity"
        />

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="add_circle"
                color="primary"
                @click="add">
                <q-tooltip anchor="top left">
                    Dodaj nową
                </q-tooltip>
            </q-btn>
        </fixed-buttons>
    </q-page>
</template>

<script>
    import FixedButtons from './FixedButtons'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import ActivityComponent from './ActivityComponent'
    import ActivityEntry from './ActivityEntry'
    export default {
        name: 'Activities',
        components: {ActivityEntry, ActivityComponent, QTooltip, QBtn, FixedButtons},
        mounted () {
            this.$emit('showRightMenu', {
                showPictures: true
            })
        },
        data () {
            return {

            }
        },
        computed: {
            activities () {
                return this.$store.getters.activity
            }
        },
        methods: {
            add () {
                this.$q.dialog({
                    title: 'Dodaj nową aktywność',
                    prompt: {
                        model: '',
                        type: 'text'
                    },
                    cancel: true
                }).then((text) => {
                    const id = this.$uuid()

                    this.$store.dispatch('create', {
                        what: 'activity',
                        item: {
                            activityTypeId: id,
                            label: text
                        },
                        id
                    })
                })

            }
        }
    }
</script>